<template lang="pug">
footer.footer
  .footer__title КОНТАКТЫ
  .footer__text Если у вас возникли вопросы или сложности при работе с сайтом, свяжитесь с техподдержкой в WhatsApp +7 977 308-08-33
  a.footer__whatsapp.mobile(href='tel:+7 (977) 308-08-33')
    img.footer__whatsapp-img(src='../static/footer.svg')
    .footer__whatsapp-text +7 (977) 308-08-33
  .footer__text Если у вас возникли вопросы по формату мероприятия, свяжитесь с Ольгой Матюхиной по телефону +7 903 107-73-77
  a.footer__whatsapp.mobile(href='tel:+7 (903) 107-73-77')
    img.footer__whatsapp-img(src='../static/footer.svg')
    .footer__whatsapp-text +7 (903) 107-73-77
  img.footer__logo(src='../static/KV_v8_neoconf.svg')
</template>

<script>
export default {
  name: 'footer',
};
</script>

<style lang="sass">
.footer
  padding: 105px 20px 37px
  box-sizing: border-box
  max-width: 913px
  margin: 0 auto
  display: flex
  flex-direction: column
  align-items: center
  @media screen and (max-width: 812px)
    padding: 40px 20px
  &__title
    font-size: 16px;
    line-height: 19px;
    letter-spacing: 2px;
    color: #FFFFFF;
    mix-blend-mode: normal;
    opacity: 0.3;
    margin-bottom: 62px
    font-weight: bold
    @media screen and (max-width: 812px)
      font-size: 14px;
      line-height: 16px;
      margin-bottom: 35px
  &__text
    font-size: 24px;
    line-height: 40px
    text-align: center;
    color: #FFFFFF;
    margin-bottom: 44px
    @media screen and (max-width: 812px)
      font-size: 24px
      line-height: 32px
      margin-bottom: 30px
  &__whatsapp
    margin-bottom: 80px
    font-size: 24px;
    line-height: 32px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #FFFFFF;
    text-decoration: none
    &-img
      margin-right: 12px
  &__logo
    width: 308px
    height: 104px
    @media screen and (max-width: 812px)
      width: 100%
      height: auto
      max-width: 320px
</style>
